module.exports = __webpack_public_path__ + "static/media/play-button.95b87eb3.svg";